import React, {useEffect, useState} from 'react'
import {
  Row,
  Col,
  CustomerDialogButtonRow,
  CompletedIcon,
  H5,
  Paragraph,
  Strong,
  InlineLoader,
} from '@modifi/ui'
import {useTranslation, formatNumber, Trans} from '@modifi/plugin-i18n'
import {primary} from '@modifi/colors'

import {ROUTE_COMPANY_TRADE_PARTNERS} from '../../../../routes/constants'
import {LimitsValue} from './styles'

type SuccessPageProps = {
  closeDialog: () => void
  redirect: (route: string) => void
  allocatedLimit?: {
    currency: string
    amount: string
  }
  tradePartnerName: string
}

const SuccessPage: React.FC<SuccessPageProps> = ({
  closeDialog,
  redirect,
  allocatedLimit,
  tradePartnerName,
}) => {
  const {t} = useTranslation('charon')

  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 3000)

    // Cleanup the timer to prevent memory leaks
    return () => clearTimeout(timer)
  }, [])

  const finalAllocatedLimit =
    allocatedLimit?.currency && parseInt(allocatedLimit?.amount, 10)
      ? formatNumber(allocatedLimit?.amount, {
          currency: allocatedLimit?.currency,
        })
      : undefined

  useEffect(() => {
    redirect(ROUTE_COMPANY_TRADE_PARTNERS)
  }, [redirect])

  if (isLoading) {
    return (
      <>
        <Row justifyContent="center" mt={32}>
          <Col auto>
            <H5>{t('seller-trade-partner.data-save-success-dialog.limits-loading.headline')}</H5>
          </Col>
        </Row>
        <Row justifyContent="center" mt={24} mb={40}>
          <Col auto>
            <InlineLoader />
          </Col>
        </Row>
      </>
    )
  }

  return (
    <>
      <Row justifyContent="center">
        <Col auto>
          <CompletedIcon height={80} width={80} color={primary} />
        </Col>
      </Row>
      <Row justifyContent="center" data-ident="trade-partner-success-dialog-headline">
        <Col auto>
          <H5>{t('seller-trade-partner.data-save-success-dialog.headline')}</H5>
        </Col>
      </Row>
      <Row justifyContent="center" mb={56}>
        <Col auto>
          <Paragraph>
            <Trans
              i18nKey="seller-trade-partner.data-save-success-dialog.description"
              components={[<Strong />]}
              t={t}
              values={{tradePartnerName}}
            />{' '}
            {finalAllocatedLimit ? (
              <>
                {t('seller-trade-partner.data-save-success-dialog.allocated-limit-label')}
                <LimitsValue>{finalAllocatedLimit}</LimitsValue>
              </>
            ) : (
              t('seller-trade-partner.data-save-success-dialog.allocated-limit-missing.label')
            )}
          </Paragraph>
        </Col>
      </Row>
      <CustomerDialogButtonRow
        canSubmit
        autoCloseDuration={18}
        onSubmitClick={closeDialog}
        onCancelClick={closeDialog}
        submitText={t('seller-trade-partner.data-save-success-dialog.cta')}
      />
    </>
  )
}

export default SuccessPage
